import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Source from './icon-source.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Source {...validProps} />;
}
SvgComponent.iconName = 'source';

export const SourceIcon = svgIconWrapper(SvgComponent);
